import { useState } from 'react';
import { useApp } from '../lib/app-context';
import { promptInstall, useInstallState } from '../lib/install';
import { Icon } from './Icon';

/** Compact "Install the app" action for empty states; nothing once installed or where it can't be offered. */
export function InstallButton() {
  const { i18n } = useApp();
  const { t } = i18n;
  const state = useInstallState();
  const [showIos, setShowIos] = useState(false);
  if (state === 'available') {
    return (
      <button className="btn" type="button" onClick={() => void promptInstall()}>
        <Icon name="download" size={18} /> {t('install.button')}
      </button>
    );
  }
  if (state === 'ios') {
    return (
      <>
        <button className="btn" type="button" aria-expanded={showIos} onClick={() => setShowIos((s) => !s)}>
          <Icon name="download" size={18} /> {t('install.addToHome')}
        </button>
        {showIos && <IosSteps />}
      </>
    );
  }
  return null;
}

function IosSteps() {
  const { i18n } = useApp();
  const { t } = i18n;
  return (
    <ol className="install-steps">
      <li>{t('install.ios1')}</li>
      <li>{t('install.ios2')}</li>
      <li>{t('install.ios3')}</li>
    </ol>
  );
}

/** Settings card: install state and how to install on this device. */
export function InstallCard() {
  const { i18n } = useApp();
  const { t } = i18n;
  const state = useInstallState();
  return (
    <section className="card stack" aria-labelledby="install-title">
      <div className="install-head">
        <img src="/brand/icon-192.png" alt="" width={48} height={48} />
        <div>
          <h2 id="install-title" className="card-title">
            {t('install.title')}
          </h2>
          <p className="muted">{t(state === 'installed' ? 'install.installed' : 'install.why')}</p>
        </div>
      </div>
      {state === 'available' && (
        <div className="row">
          <button className="btn btn-primary" type="button" onClick={() => void promptInstall()}>
            <Icon name="download" size={18} /> {t('install.button')}
          </button>
        </div>
      )}
      {state === 'ios' && <IosSteps />}
      {state === 'unsupported' && <p className="hint">{t('install.other')}</p>}
    </section>
  );
}
